
import universal from 'react-universal-component';

export default universal(() => import('./Details'));



// WEBPACK FOOTER //
// ./src/app/views/Custom/Details/index.js